import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import { useStores } from '@/hooks/use-stores';
import { metricsDetails } from '@/constants';
import { MetricType } from '@/constants/metric-type.enum';

import CustomGauge from './CustomGauge';

interface PressureDropCustomGaugeProps {
  entity: {
    index: number;
    fromDeviceId: string;
    toDeviceId: string;
    upperThreshold?: number;
    lowerThreshold?: number;
  };
}

const PressureDropCustomGauge = observer(({ entity }: PressureDropCustomGaugeProps) => {
  const { fromDeviceId, toDeviceId, upperThreshold, lowerThreshold } = entity;
  const { stationStore } = useStores();
  const { t } = useTranslation();
  const { currentStation } = stationStore;
  const metric = MetricType.PressureBar;
  const fromDevice = currentStation.devices.find(device => device.deviceId === fromDeviceId);
  const toDevice = currentStation.devices.find(device => device.deviceId === toDeviceId);

  const getUnit = (): string => {
    return metricsDetails[metric].unit;
  };

  const getValue = (): string | number => {
    if (fromDevice?.pressureBar === undefined || toDevice?.pressureBar === undefined) {
      return '--';
    }
    return fromDevice?.pressureBar - toDevice?.pressureBar;
  };

  return (
    <CustomGauge
      title={t('Pressure Drop')}
      subtitle={`${fromDevice?.name} - ${toDevice?.name}`}
      value={getValue()}
      unit={getUnit()}
      lowerThreshold={lowerThreshold}
      upperThreshold={upperThreshold}
    />
  );
});

export default PressureDropCustomGauge;
